export default __webpack_public_path__ + "locales/ko-KR/Payments.json?hash=da40f3c6365c120cd546ab29aa6c33a4";